import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RemoteFormData, ColumnFieldTitle, OfbizField, OfbizList } from '@urbannex/ofbiz-forms';
import { getFields, getColumnFieldTitles } from '@urbannex/view-containers';
import { PART_FORMS } from '../../../../forms';

@Component({
  selector: 'pty-customer-credit-card',
  templateUrl: './customer-credit-card.component.html',
  styleUrls: ['./customer-credit-card.component.scss']
})
export class CustomerCreditCardComponent implements OnChanges{
  @Input() partyId:string;
  listForm:OfbizList;
  
  title:"Credit Card";
  fieldOptions:any;
  state$:any;
  isLookup:false;
  cardMode:true;
  remoteFormData:RemoteFormData;
  columnFieldTitles:ColumnFieldTitle[];
  columnFields:OfbizField[];
  listOptions:any;
  hasRemoteData = false;

  constructor(){}
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["partyId"]){
      this.listForm = new OfbizList({
        listFormName:"CustomerCreditCardPaymentMethods",
        listFormLocation: "component://kwikstore/widget/PartyForms.xml",
        columnFields: getFields("CustomerCreditCardPaymentMethods", PART_FORMS),
        columnFieldTitles:getColumnFieldTitles("CustomerCreditCardPaymentMethods",PART_FORMS),
        //fieldFormFields:any,
        listType:"list",
        emptyListMessage:"No Postal Addresses found for this customer",
        remoteFormData:{
          formData:{
            formName:"CustomerCreditCardPaymentMethods",
            formLocation:"component://kwikstore/widget/PartyForms.xml",
            viewIndex:0,
            listType:"grid",
          },
          parameters:{"partyId":this.partyId,"paymentMethodTypeId":"CREDIT_CARD"},
          endPoint:"partymgr"
        }
      })
      this.remoteFormData = {
        formData:{
          formName:"CustomerCreditCardPaymentMethods",
          formLocation:"component://kwikstore/widget/PartyForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        parameters:{"partyId":this.partyId,"paymentMethodTypeId":"CREDIT_CARD"},
        endPoint:"partymgr"
      };
      this.columnFields = getFields("CustomerCreditCardPaymentMethods",PART_FORMS),
      this.columnFieldTitles = getColumnFieldTitles("CustomerCreditCardPaymentMethods",PART_FORMS),
      this.state$.remoteFormData = this.remoteFormData;
      this.hasRemoteData = true;
      console.log(this.remoteFormData);
    }
  }


}
